import { ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';
import websiteConfig from '@/configs/websiteConfig';
export default function () {
  const charRef = ref(null);
  const targetIsVisible = ref(false);
  const { isSupported } = useIntersectionObserver(charRef, ([{ isIntersecting }], observerElement) => {
    !targetIsVisible.value && (targetIsVisible.value = isIntersecting);
  });
  return {
    charRef,
    targetIsVisible,
    isSupported,
    thirdParty: websiteConfig.thirdParty,
  };
}
